import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { observable } from 'mobx';
import FetchView from '../../../dumb/FetchView/FetchView';
import { Table, TableCell, TableHead, TableBody, TableRow, IconButton, TextField } from '@material-ui/core';
import { Container, Modal, Heading, Button } from 'react-bulma-components';
import DeleteIcon from '@material-ui/icons/Delete';
import AccountsStore from 'stores/AccountsOverview/AccountsStore';
import { toast } from 'react-toastify';

@observer
class GroupList extends Component {
  @observable accessor localstate = {
    search: '',
    newGroupName: '',
    showCreateConfirmation: false,
    showAddGroupModal: false,
    showDeleteConfirmation: false,
    groupToDelete: null,
  };

  filterList(item) {
    const search = this.localstate.search.toLowerCase();
    if (!search) return true;

    if (item.name && item.name.toLowerCase().includes(search)) return true;

    return false;
  }

  sortList(a, b) {
    const key = 'name';
    const prev = a[key];
    const next = b[key];
    return prev === next ? 0 : prev > next ? 1 : -1;
  }

  handleDelete = async () => {
    const { groupToDelete } = this.localstate;
    try {
      await AccountsStore.deleteItem(groupToDelete,'groups');
      toast.success('Grouo deleted successfully.');
      this.localstate.showDeleteConfirmation = false;
      this.localstate.groupToDelete = null;
    } catch (error) {
      console.error('Failed to delete item:', error);
      toast.error('Failed to delete account group.');
    }
  };

  openDeleteConfirmation = (item) => {
    this.localstate.showDeleteConfirmation = true;
    this.localstate.groupToDelete = item;
  };

  closeDeleteConfirmation = () => {
    this.localstate.showDeleteConfirmation = false;
    this.localstate.groupToDelete = null;
  };

  openAddGroupModal = () => {
    this.localstate.showAddGroupModal = true;
  };

  closeAddGroupModal = () => {
    this.localstate.showAddGroupModal = false;
    this.localstate.newGroupName = '';
  };

  handleCreateGroup = () => {
    const { newGroupName } = this.localstate;
    const existingGroup = AccountsStore.list.groups.find(group => group.name === newGroupName);

    if (existingGroup) {
      toast.error('Account group already exists.');
    } else {
      this.localstate.showCreateConfirmation = true;
    }
  };

  handleConfirmCreate = async () => {
    const { newGroupName } = this.localstate;
    try {
      await AccountsStore.createItem({ name: newGroupName }, 'groups');
      toast.success('Account group created successfully.');
      this.localstate.showCreateConfirmation = false;
      this.localstate.newGroupName = '';
      this.localstate.showAddGroupModal = false;
    } catch (error) {
      toast.error('Failed to create account group.');
    }
  };

  render() {
    const { search, newGroupName, showCreateConfirmation, showAddGroupModal, showDeleteConfirmation } = this.localstate;
    const { isOpen, onClose } = this.props;

    return (
      <Modal show={isOpen} onClose={onClose}>
        <Modal.Card style={{ width: '65%' }}>
          <Modal.Card.Header>
            <Modal.Card.Title>Manage Account Groups</Modal.Card.Title>
          </Modal.Card.Header>
          <Modal.Card.Body>
            <Container style={{ padding: '20px' }}>
              <Heading style={{ textAlign: 'center', margin: '30px 0' }}>Account Groups</Heading>
              <Button onClick={this.openAddGroupModal} style={{ marginBottom: '20px', float: 'right' }}>
                Add Group
              </Button>
              <FetchView stores={[AccountsStore]}>
                <Table aria-label="simple table" stickyHeader style={{ marginTop: '15px' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: '80%' }}>Name</TableCell>
                      <TableCell style={{ width: '20%' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(AccountsStore?.list?.groups || [])
                      .filter(this.filterList.bind(this))
                      .sort(this.sortList.bind(this))
                      .map((item, i) => (
                        <TableRow key={i}>
                          <TableCell style={{ width: '80%' }}>{item.name}</TableCell>
                          <TableCell style={{ width: '20%' }}>
                            <IconButton
                              color="secondary"
                              onClick={() => this.openDeleteConfirmation(item)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </FetchView>
            </Container>
          </Modal.Card.Body>
          <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
            <Button color="grey" onClick={onClose} style={{ width: '150px' }}>Close</Button>
          </Modal.Card.Footer>
        </Modal.Card>

        <Modal show={showAddGroupModal} onClose={this.closeAddGroupModal}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Add New Account Group</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <TextField
                label="Group Name"
                value={newGroupName}
                onChange={(e) => (this.localstate.newGroupName = e.target.value)}
                fullWidth
              />
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleCreateGroup}>Add</Button>
              <Button onClick={this.closeAddGroupModal}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showCreateConfirmation} onClose={() => (this.localstate.showCreateConfirmation = false)}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Confirm Creation</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Do you want to create a new account group with the name "{newGroupName}"?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleConfirmCreate}>Yes, Create</Button>
              <Button onClick={() => (this.localstate.showCreateConfirmation = false)}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showDeleteConfirmation} onClose={this.closeDeleteConfirmation}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Confirm Deletion</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Are you sure you want to delete this account group?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button onClick={this.handleDelete}>Yes, Delete</Button>
              <Button onClick={this.closeDeleteConfirmation}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>
      </Modal>
    );
  }
}

export default GroupList;